export const ADMIN_MOET_UNIT_PERMISSION = {
    perm1: "core_admin_moet_units",
    perm2: "core_admin_moet_unit_add",
    perm3: "core_admin_moet_unit_detail",
    perm4: "core_admin_moet_unit_edit",
    perm5: "core_admin_moet_unit_delete",
    perm6: "core_admin_moet_unit_move",
    perm7: "core_admin_moet_unit_import",
}
